/* eslint-disable global-require */
module.exports = ['lots.indicator.table.m1', 'artprice.mystore.advert.info.m19', 'artprice.lib.result.indexresult.m30'];
